export default "__VITE_ASSET__lSf82HN6__"